import { Col, Input, Row } from 'reactstrap'
import styles from './BasicInformation.module.scss'

const BasicInformation = () => {

  return (
    <div>
      <div className={styles['heading']}>Basic Information</div>
      <div className='p-2 bg-white'>

        <div className={styles['wrapper']}>
          <Row className='g-0 align-items-center'>
            <Col sm='12' lg='2'>
              Campaign Name:
            </Col>
            <Col sm='12' lg='4'>
              <Input placeholder='Enter name of the product' />
            </Col>
          </Row>
          <Row className='g-0 align-items-center'>
            <Col sm='12' lg='2'>
              Ad Name:
            </Col>
            <Col sm='12' lg='4'>
              <Input placeholder='Enter name of the product' />
            </Col>
          </Row>
          <Row className='g-0 align-items-center'>
            <Col xs='12' lg='2'>
              Start date:
            </Col>
            <Col xs='12' lg='4'>
              <Input type='date' />
            </Col>
          </Row>
          <Row className='g-0 align-items-center'>
            <Col sm='12' lg='2'>
              End date:
            </Col>
            <Col sm='12' lg='4'>
              <Input type='date' />
            </Col>
          </Row>
          <Row className='g-0 align-items-center'>
            <Col sm='12' lg='2'>
              Daily Budget:
            </Col>
            <Col sm='12' lg='4'>
              <Input placeholder='Choose from dropdown menu' />
            </Col>
          </Row>
        </div>
      </div>

    </div>
  )

}

export default BasicInformation